import { useEffect, useRef } from "react";

export const useDelayedAction = (delayCondition) => {
  const delayedFnRef = useRef(null);

  const delayAction = (actionFn) => {
    if (delayCondition) {
      delayedFnRef.current = actionFn;
    } else {
      actionFn();
    }
  };

  useEffect(() => {
    if (delayedFnRef.current && !delayCondition) {
      delayedFnRef.current();
      delayedFnRef.current = null;
    }
  }, [delayCondition, delayedFnRef]);

  return delayAction;
};
